import * as React from 'react';
import * as Colors from '../../consts/variables';
import { getSortingBasedOnMarket } from '../../helpers/getSortingBasedOnMarket';
import { post } from '../../helpers/http';
import { __ } from '../../helpers/TranslationService';
import { ICountryCode } from '../../interfaces';
import { SearchIcon } from '../Icons/SearchIcon';

const styles: Record<string, React.CSSProperties> = {
    searchCruiseFormWrapper: {
        padding: '0 5%',
        marginBottom: '15px',
    },
    searchCruiseForm: {
        border: '1px solid rgb(195, 195, 195)',
        margin: '0 auto',
        maxWidth: '290px',
    },
    inputCruiseId: {
        border: 0,
        padding: '5px 7px',
        width: '85%',
        height: '40px',
        outline: '0',
    },
    inputCruiseIdButton: {
        border: 0,
        background: 'none',
        position: 'relative',
        top: '5px',
        outline: '0',
        padding: '0',
        left: '5px',
    },
};

const IconStyle: any = {
    marginRight: '5%',
    fill: Colors.darkAcqa,
    flex: '0 0 auto',
    alignSelf: 'flex-start',
};
interface IState {
    cruiseNid: string;
}

interface IProps {
    countryCode: string;
    apiHost: string;
    brandConfigSlugs: { slugName: string; slugValue: string }[];
    contentEndpoint: string;
}

export class SearchCruise extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            cruiseNid: '',
        };
    }

    replaceRelevanceSortString(): string {
        return getSortingBasedOnMarket({ market: this.props.countryCode as ICountryCode });
    }

    handleChange = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ cruiseNid: e.target.value });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { apiHost, brandConfigSlugs, contentEndpoint } = this.props;
        const url = `${apiHost}/cruises/search`;
        const searchSlug = brandConfigSlugs.find((item) => item.slugName === 'searchresults')
            .slugValue;
        const urlNotFound = `${contentEndpoint}/${searchSlug}?cruiseNids=${this.state.cruiseNid}`;
        const relevanceSortString: string = this.replaceRelevanceSortString();
        const searchParams = {
            filterParams: {
                cruiseNids: this.state.cruiseNid,
            },
            limit: 1,
            offset: 0,
            sortString: relevanceSortString,
            page: 1,
        };
        if (this.state.cruiseNid.length) {
            post(url, searchParams)
                .then((res) => {
                    const cruises = res.cruises;
                    if (cruises?.length) {
                        window.location.href = `${contentEndpoint}${cruises[0].cruisePageUrl}`;
                    } else {
                        window.location.href = urlNotFound;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    render() {
        return (
            <div style={styles.searchCruiseFormWrapper}>
                <form style={styles.searchCruiseForm} onSubmit={this.handleSubmit}>
                    <input
                        style={styles.inputCruiseId}
                        type="tel"
                        value={this.state.cruiseNid || ''}
                        onChange={this.handleChange}
                        placeholder={__('insert cruise ID', 'dreamlines')}
                    />
                    <button style={styles.inputCruiseIdButton}>
                        <SearchIcon style={IconStyle} width={24} height={24} />
                    </button>
                </form>
            </div>
        );
    }
}
